/**
 * Unique Google Analytics code for app.mfc
 */
export const GA_TRACKING_ID = 'G-HX90SYNGDN'

/**
 * Send a PageView to Google Analytics (if NODE_ENV === 'production')
 * https://developers.google.com/analytics/devguides/collection/gtagjs/pages
 * @param {*} url
 */
export const pageview = (url) => {
    if (shouldReportAnalytics()) {
        window.gtag('config', GA_TRACKING_ID, {
            page_path: url,
        })
        // console.log(`Sending PageView to Google Analytics: ${url}`)
    }
}

/**
 * Send an event to Google Analytics (if NODE_ENV === 'production')
 * https://developers.google.com/analytics/devguides/collection/gtagjs/events
 * @param {*} param0
 */
export const event = ({ action, category, label, value }) => {
    if (shouldReportAnalytics()) {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        })
        // console.log(
        //     `Sending Event to Google Analytics: ${action}: ${category} [${label}]: ${value}`,
        // )
    }
}

/**
 * Check to see if we are on app.myfreecams.com
 */
export const shouldReportAnalytics = () => {
    if (typeof window !== 'undefined' && window.gtag) return true
    return false
}
